import type { ReactNode } from 'react';

interface EyebrowProps {
  readonly children: ReactNode;
  /** Sobre fondo oscuro el azul de marca no contrasta; se aclara. */
  readonly tone?: 'brand' | 'light';
  readonly className?: string;
}

/**
 * Etiqueta superior de sección con la regla de 36×2px.
 *
 * El texto ya viene en mayúsculas desde el contenido (no vía text-transform)
 * para que los lectores de pantalla no lo deletreen letra a letra, que es lo
 * que hacen algunos con las siglas en caja alta real.
 */
export function Eyebrow({
  children,
  tone = 'brand',
  className = '',
}: EyebrowProps) {
  const color = tone === 'brand' ? 'text-brand' : 'text-brand-pale';
  const rule = tone === 'brand' ? 'bg-brand' : 'bg-brand-pale';

  return (
    <p
      className={`flex items-center gap-3.5 font-display text-xs font-semibold tracking-[0.24em] ${color} ${className}`}
    >
      <span className={`inline-block h-0.5 w-9 shrink-0 ${rule}`} aria-hidden="true" />
      {children}
    </p>
  );
}

interface SectionTitleProps {
  readonly children: ReactNode;
  readonly tone?: 'dark' | 'light';
  readonly className?: string;
}

/**
 * H2 de sección. El tamaño usa clamp() en lugar de breakpoints: escala de forma
 * continua entre móvil y desktop en vez de dar saltos.
 */
export function SectionTitle({
  children,
  tone = 'dark',
  className = '',
}: SectionTitleProps) {
  return (
    <h2
      className={`text-[clamp(1.7rem,3.4vw,2.7rem)] leading-[1.12] ${
        tone === 'dark' ? 'text-ink' : 'text-white'
      } ${className}`}
    >
      {children}
    </h2>
  );
}
